import React from "react";
import styled from "@emotion/styled";
import Display from "../Display";

const Container = styled.div`
  flex: 1;
  height: 120px;
  width: 100%;
`;

function DisplayRowContent({ display }) {
  return (
    <Container>
      <Display display={display} />
    </Container>
  );
}

export default DisplayRowContent;
